module.exports = __webpack_public_path__ + "media/about/AboutUs-Hero-Mobile-c706b32e.jpg";